import { WatchmanFetch } from '../../../shared/utils/watchmanFetch';
import type { TeamMember, Role, CreateTeamMemberPayload, UpdateTeamMemberPayload } from '../types';

// PE-2109 — merchant team management. Every call goes through osprey-api's /iam
// proxy to watchman, which scopes /users to the CALLER's own merchant for
// MERCHANT-scoped roles (no merchantId needed from the client) and enforces
// USER.* server-side. GET /users returns a bare UserResponseDto[] (not paginated).
export const teamApi = {
  list: (): Promise<TeamMember[]> => WatchmanFetch.get('/users'),
  create: (data: CreateTeamMemberPayload): Promise<TeamMember> => WatchmanFetch.post('/users', data),
  update: (id: string, data: UpdateTeamMemberPayload): Promise<TeamMember> =>
    WatchmanFetch.patch(`/users/${id}`, data),
  delete: (id: string): Promise<void> => WatchmanFetch.del(`/users/${id}`),
};

export const rolesApi = {
  list: (): Promise<Role[]> => WatchmanFetch.get('/roles'),
};
